export const accountsReceivableFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  {
    field: 'invoiceNumber',
    title: 'Invoice #',
    cell: 'navigation',
    sortable: true,
  },
  {
    field: 'invoiceDate',
    title: 'Invoice Date',
    sortable: true,
  },
  {
    field: 'company',
    title: 'Company',
    sortable: true,
  },
  {
    field: 'invoiceTotal',
    title: 'Invoice Total',
    sortable: true,
  },
  {
    field: 'amountDue',
    title: 'Amount Due',
    sortable: true,
  },
];

export const authorizationCenterFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  {
    field: 'invoiceNumber',
    title: 'Invoice #',
    cell: 'navigation',
    sortable: true,
  },
  {
    field: 'soNumber',
    title: 'Sales Order Number',
    sortable: true,
  },
  {
    field: 'company',
    title: 'Company',
    sortable: true,
  },
  {
    field: 'authorize',
    title: 'Authorize',
    sortable: true,
  },
  {
    field: 'hold',
    title: 'Hold',
    sortable: true,
  },
  {
    field: 'terms',
    title: 'Terms',
    sortable: true,
  },
  {
    field: 'grossProfit',
    title: 'Gross Profit',
    sortable: true,
  },
  {
    field: 'buyerTotal',
    title: 'Buyer Total',
    sortable: true,
  },
  {
    field: 'total',
    title: 'Total',
    sortable: true,
  },
];

export const upcomingBillsFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  {
    field: 'company',
    title: 'Company',
    sortable: true,
  },
  {
    field: 'dueDate',
    title: 'Due Date',
    sortable: true,
  },
  {
    field: 'amount',
    title: 'Amount',
    sortable: true,
  },
];

export const pastDueBillsFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  {
    field: 'company',
    title: 'Company',
    sortable: true,
  },
  {
    field: 'dueDate',
    title: 'Due Date',
    sortable: true,
  },
  {
    field: 'amount',
    title: 'Amount',
    sortable: true,
  },
];

export const chartsOfAccountsFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  {
    field: 'name',
    title: 'Name',
    sortable: true,
  },
  {
    field: 'glAccountNumber',
    title: 'GL Account #',
    sortable: true,
  },
  {
    field: 'type',
    title: 'Type',
    sortable: true,
  },
  {
    field: 'balance',
    title: 'Balance',
    sortable: true,
  },
  {
    field: 'total',
    title: 'Total',
    sortable: true,
  },
];

export const expensesFields = [
  {
    field: 'expenseAccountName',
    title: 'Name',
    sortable: false,
    cell: 'navigation',
  },
  {
    field: 'amount',
    title: 'Amount',
    cell: 'formatCurrencyConverted',
    sortable: false,
  },
];

export const revenueFields = [
  {
    field: 'name',
    title: 'Company Name',
    sortable: false,
    cell: 'navigation',
  },
  {
    field: 'amount',
    title: 'Amount',
    cell: 'formatCurrencyConverted',
    sortable: false,
  },
]

export const credtMemoSummaryFields = [
  {
    field: 'companyName',
    title: 'Company Name',
    sortable: true,
    cell: 'navigation',
  },
  {
    field: 'balance',
    title: 'Amount',
    cell: 'formatCurrencyConverted',
    sortable: true,
  },
];

//export default defaultFields;
